import type hast from 'hast';
import type { Plugin } from 'unified';

import { visuallyHidden } from '@lumapps/classnames';

import { isElement, isParent } from './utils';

/** Check that a HAST element has the `visually-hidden` class. */
const isVisuallyHidden = (node: hast.Node): boolean => {
    if (!isElement(node)) {
        return false;
    }
    const className = node.properties?.className;
    return Array.isArray(className) && className.includes(visuallyHidden());
};

/**
 * Rehype plugin that strips visually-hidden elements from the HAST tree before
 * it is converted to slate nodes.
 */
export const rehypeRemoveVisuallyHidden: Plugin<[], hast.Root> = () =>
    function transform(node) {
        if (!isParent(node)) {
            return node;
        }
        // Remove visually-hidden children in place (avoid reassigning the parameter).
        for (let i = node.children.length - 1; i >= 0; i--) {
            if (isVisuallyHidden(node.children[i])) {
                node.children.splice(i, 1);
            } else {
                transform(node.children[i]);
            }
        }
        return node;
    };
